import React, { Component } from "react";
import { connect } from "react-redux";
import { Button } from "@mui/material";
import { CONSTANTS } from "utilities/constants";
import { withLocalizer } from "utilities/withLocalizer";
import ItineraryInfo from "./customizeSteps/common/itineraryInfo";
import contentHelper from "utilities/contentHelper";
import commonUtilities from "utilities/common";

import "./customize.scss";

class StepConfirmation extends Component {
    constructor(props) {
        super(props);
    }

    render() {
        const { data, events, customQuote } = this.props;
        const { currentStep } = data;

        const TODAY = commonUtilities.getTodayDate();

        let allExpiryDatesUnChanged = false;
        let itinerariesToRender = [];

        if(currentStep === 1) {
        
            const validItineraries =
                customQuote?.data?.quoteOptions?.flatMap(option =>
                    option?.products?.flatMap(product =>
                        product?.itineraries
                            ?.filter(itinerary => {
                                if (!itinerary?.included) return false;

                                const durationToToday =
                                    commonUtilities.calculateDuration(
                                        TODAY,
                                        itinerary.originalValidDate
                                    );

                                return durationToToday > 0;
                            })
                            .map(itinerary => ({
                                option,
                                product,
                                itinerary
                            })) ?? []
                    ) ?? []
                ) ?? [];

            itinerariesToRender = validItineraries.filter(
                ({ itinerary }) =>
                    !contentHelper.itineraryExpiryDateChanged(itinerary)
            );

            const allExpiryDates = validItineraries.map(
                ({ itinerary }) => itinerary.originalValidDate
            );

            const expiryDatesUnChanged = validItineraries
                .filter(({ itinerary }) =>
                    !contentHelper.itineraryExpiryDateChanged(itinerary)
                )
                .map(({ itinerary }) => itinerary.validDate);

            allExpiryDatesUnChanged =
                allExpiryDates.length === expiryDatesUnChanged.length;
        }
        
        if(currentStep === 2) {
            itinerariesToRender = 
                customQuote?.data?.quoteOptions?.flatMap(option =>
                    option?.products?.flatMap(product =>
                        product?.itineraries
                            ?.filter(itinerary => {
                                if (!itinerary?.included) return false;

                                const { adult, child } =
                                    contentHelper.validateMarkup(
                                        itinerary?.markup,
                                        itinerary.adultOnly
                                    );

                                // keep ONLY itineraries that fail validation
                                return !(adult && child);
                            })
                            .map(itinerary => ({
                                option,
                                product,
                                itinerary
                            })) ?? []
                    ) ?? []
                ) ?? [];
        }

        let btnCancelLabel = (currentStep === 1 ?  
            this.props.localize("qma-custom-quote-step-1-confirmation-cancel-label") :
            (currentStep === 2 ? 
                this.props.localize("qma-custom-quote-step-2-confirmation-cancel-label") : 
                ( currentStep === 3 ? this.props.localize("qma-custom-quote-step-3-confirmation-cancel-label") : 
                    (currentStep === 4 ? this.props.localize("qma-custom-quote-step-4-confirmation-cancel-label") :
                        (currentStep === 5 ? this.props.localize("qma-custom-quote-step-5-confirmation-cancel-label") :
                            currentStep === 6 ? this.props.localize("qma-custom-quote-step-6-confirmation-cancel-label") : this.props.localize("qma-cancel"))))));

        let index = 0; 
        return (
            <div className="show">
                <div className="popup-container-bg"></div>

                <div className="popup-container confirmation-popup customizable-quote">

                    <div className="popup-body">
                        { currentStep === 1 ? 
                            (allExpiryDatesUnChanged ? 
                                <div className="popup-heading margin-top-2x">
                                    { this.props.localize("qma-custom-quote-step-1-all-not-changed-error") }
                                    { " " }
                                    { this.props.localize("qma-custom-quote-step-1-all-not-changed-question") }
                                </div>
                                :
                                <>
                                    <div className="popup-heading margin-top-2x">
                                        { this.props.localize("qma-custom-quote-step-1-some-not-changed-error") }    
                                    </div>
                                    <div className="text-align-left margin-top-1x margin-bottom-1x">
                                        {itinerariesToRender.map(({ option, product, itinerary }) => (
                                            <div
                                                key={`${option.id}-${product.id}-${itinerary.itineraryNumber}`}
                                                className="custom-quote-editor-panel-wrapper show"
                                            >
                                                <div className="custom-quote-editor-panel">
                                                    <div className="d-flex">
                                                        <div className="col-itinerary-selector">
                                                            {itinerary.itineraryNumber}.
                                                        </div>

                                                        <div className="col-itinerary-info">
                                                            <ItineraryInfo
                                                                option={option}
                                                                product={product}
                                                                itinerary={itinerary}
                                                            />
                                                        </div>
                                                    </div>
                                                </div>
                                            </div>
                                        ))}
                                    </div>
                                    <div className="question">
                                        { this.props.localize("qma-custom-quote-step-1-some-not-changed-question") }
                                    </div>
                                    
                                </>)
                            : null
                        }
                        { currentStep === 2 ?
                            <>
                                <div className="popup-heading margin-top-2x">
                                    { this.props.localize("qma-custom-quote-step-2-confirmation-error") }
                                </div>
                                <div>
                                    {customQuote?.data?.markupCoverage === CONSTANTS.MARKUP_COVERAGE_ALL ? " " :
                                        <div className="text-align-left margin-top-1x margin-bottom-1x">
                                            {itinerariesToRender.map(({ option, product, itinerary }) => (
                                                <div
                                                    key={`${option.id}-${product.id}-${itinerary.itineraryNumber}`}
                                                    className="custom-quote-editor-panel-wrapper show"
                                                >
                                                    <div className="custom-quote-editor-panel">
                                                        <div className="d-flex">
                                                            <div className="col-itinerary-selector">
                                                                {itinerary.itineraryNumber}.
                                                            </div>

                                                            <div className="col-itinerary-info">
                                                                <ItineraryInfo
                                                                    option={option}
                                                                    product={product}
                                                                    itinerary={itinerary}
                                                                />
                                                            </div>
                                                        </div>
                                                    </div>
                                                </div>
                                            ))}
                                        </div>
                                    }
                                    
                                </div>
                                <div className="question">
                                    { this.props.localize("qma-custom-quote-step-2-confirmation-question") }
                                </div>
                            </>
                            : null
                        }
                        { currentStep === 3 ?
                            <div className="popup-heading margin-top-2x">
                                { this.props.localize("qma-custom-quote-step-3-confirmation-error") }{" "}
                                { this.props.localize("qma-custom-quote-step-3-confirmation-question") }
                            </div>
                            : null
                        }
                        { currentStep === 4 ?
                            <div className="popup-heading margin-top-2x">
                                { this.props.localize("qma-custom-quote-step-4-confirmation-error") }{" "}
                                { this.props.localize("qma-custom-quote-step-4-confirmation-question") }
                            </div>
                            : null
                        }
                        { currentStep === 5 ?
                            <>
                                <div className="popup-heading margin-top-2x">
                                    { this.props.localize("qma-custom-quote-step-5-confirmation-error") }
                                </div>
                                <div className="text-align-left margin-top-1x margin-bottom-1x">
                                    <ul className="info-list">
                                        {customQuote?.data?.termsAndConditions.filter(term => !term.isChanged).map((term, index) => 
                                            <li key={index}>
                                                {term.title}
                                            </li>
                                        )}
                                    </ul>
                                </div>
                                <div className="question">
                                    { this.props.localize("qma-custom-quote-step-5-confirmation-question") }
                                </div>
                            </>
                            : null
                        }
                        { currentStep === 6 ?
                            <div className="popup-heading margin-top-2x">
                                { this.props.localize("qma-custom-quote-step-6-confirmation-error") }{" "}
                                { this.props.localize("qma-custom-quote-step-6-confirmation-question") }
                            </div>
                            : null
                        }
                        <div className="row margin-top-3x action-buttons action-buttons-responsive">

                            <Button
                                onClick={events.handleCancel}
                                variant="outlined">
                                {btnCancelLabel}
                            </Button>

                            <Button
                                onClick={events.handleContinue}
                                variant="contained">
                                { this.props.localize("qma-yes-continue") }
                            </Button>

                        </div>
                    </div>
                </div>
            </div>
        );

    }
}
const mapStateToProps = (state) => ({
    customQuote: state.customQuote
});

export default connect(mapStateToProps)(withLocalizer(StepConfirmation));